import React     from "react"
import { Table } from "semantic-ui-react"
import Price     from "components/Price/Price";


const PositionRow = ( { position, product } ) => {
  const useProductData = product && product.extras
  console.log('CARTROW',product,position);
  return (
    <Table.Row>
      <Table.Cell>{position.article_nr}</Table.Cell>
      <Table.Cell><span className="f5">{position.desc}</span><br/>
        {useProductData && <div className="f6 black-60"><span className="">{product.extraValue.Variante},</span> <span
          className="black-60 d6 ">{product.extraValue.groesse}</span></div>}
      </Table.Cell>
      <Table.Cell className="tl">{position.count} {translate( "PU" )} <br/>
        <div className="black-60 d6 ">{position.count * position.unit_multi} {translate( "piece" )}</div>
      </Table.Cell>
      {position.extras.custom_price_sum && <Table.Cell className="tr"><Price>{position.extras.custom_price_sum}</Price></Table.Cell>}
      {!position.extras.custom_price_sum && <Table.Cell className="tr"><Price>{position.price * position.unit_multi}</Price></Table.Cell>}
      {shop.session.handId && <Table.Cell className="tr"><span>{position.extras.custom_discount}%</span></Table.Cell>}
      <Table.Cell className="tr"><Price>{position.sum}</Price></Table.Cell>
    </Table.Row>
  )
}


import shop          from "shop/shop"
import { translate } from "translate"

const SuccessTable = ( { positions, netto, byId, discountSum = 0 } ) => {
  const hasValidDiscount = !isNaN( discountSum ) && discountSum > 0
  return (
    <Table>
      <colgroup>
        <col width="10%"/>
        <col width="45%"/>
        <col width="15%"/>
        <col width="15%"/>
        <col width="15%"/>
      </colgroup>

      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{translate( "article" )}</Table.HeaderCell>
          <Table.HeaderCell>&nbsp;</Table.HeaderCell>
          <Table.HeaderCell className="tl">{translate( "Anzahl" )}</Table.HeaderCell>
          <Table.HeaderCell className="">{translate( "Preis" )}</Table.HeaderCell>
          {(hasValidDiscount && shop.session.handId) && <Table.HeaderCell className="">{translate( "Rabatt" )}</Table.HeaderCell>}
          <Table.HeaderCell className="">{translate( "Summe" )}</Table.HeaderCell>
        </Table.Row>

      </Table.Header>

      <Table.Body>

        {positions.map( ( position ) => {
          const product = byId[ position.article_id ]
          return <PositionRow key={position.article_id} position={position} product={product}/>
        } )}


        <Table.Row>
          <Table.Cell textAlign={"right"} className="netto-sum tr" colSpan="7">{translate( "Gesamtpreis netto" )}: <Price>{netto}</Price></Table.Cell>
        </Table.Row>

        {/* DISCOUNTS!*/}
        {shop.session.handId &&
          <React.Fragment>
            {hasValidDiscount && <React.Fragment>
              <Table.Row>
                <Table.Cell
                  colSpan="7"
                  textAlign={"right"}
                  title={"Ohne Gewähr: Die Rabatt-Anzeige berücksichtigt u.U. nicht alle verfügbaren Preis-/Rabattgruppen. "}><span
                  className="f5 b black-50">{translate( "Rabatt" )}*</span>
                  <span className="f5 b black-50 tr">- <Price>{discountSum}</Price></span>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell
                  colSpan="7"
                  textAlign={"right"}
                  title={"Ohne Gewähr: Die Rabatt-Anzeige berücksichtigt u.U. nicht alle verfügbaren Preis-/Rabattgruppen. "}><span
                  className="f5 b black-50">{translate( "Summe nach Rabatt" )}*</span>
                  <span className="f5 b black-50 tr"> <Price>{netto - discountSum}</Price></span>
                </Table.Cell>
              </Table.Row>
            </React.Fragment>}
          </React.Fragment>
        }
      </Table.Body>
    </Table>
  )
}

export default SuccessTable



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Product/SuccessTable.js